import styled from "styled-components";

export interface IToggleDisplayProps {
  shouldDisplay: boolean;
}

const ToggleDisplay = styled.div<IToggleDisplayProps>`
  display: ${props => (props.shouldDisplay ? "inherit" : "none")};
`;

export default ToggleDisplay;
